import { render } from "./cardsResumReserves.vue?vue&type=template&id=0d154012"
import script from "./cardsResumReserves.vue?vue&type=script&lang=js"
export * from "./cardsResumReserves.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__